"use strict";
$(function () {
    const notificationClosedKey = "ActiveNotificationClosed";
    const notificationDataKey = "NotificationData";
    const isClosed = sessionStorage.getItem(notificationClosedKey) === "true";
    let notificationData = sessionStorage.getItem(notificationDataKey);
    if (notificationData) {
        let notificationInfo = JSON.parse(notificationData);
        $("#systemNotificationToggle").show();
        wireNavbarToggle(notificationInfo);
        if (!isClosed) {
            displayNotification(notificationInfo);
        }
    }
    else {
        $("#systemNotificationToggle").hide();
    }
    $.ajax({
        url: getNotificationUrl,
        type: "GET",
        async: true,
        success: function (response) {
            if (response == null) {
                clearNotificationCache();
                $("#systemNotificationToggle").hide();
                return;
            }
            if (response) {
                let notificationInfo = {
                    id: response.Id,
                    cookieName: "system-notification-" + response.UpdatedStamp,
                    text: response.LocalizedMessage,
                    themeClass: "light",
                    daysUntilExpiry: response.daysUntilExpiry,
                    position: "top",
                };
                if (!isClosed) {
                    displayNotification(notificationInfo);
                }
                sessionStorage.setItem(notificationDataKey, JSON.stringify(notificationInfo));
                $("#systemNotificationToggle").show();
                wireNavbarToggle(notificationInfo);
            }
        },
    });
});
function clearNotificationCache() {
    sessionStorage.removeItem("NotificationData");
    sessionStorage.removeItem("ActiveNotificationClosed");
    $("#systemNotificationToggle").hide();
}
function displayNotification(notificationInfo) {
    const popupId = `system-notification-popup-container-${notificationInfo.id}`;
    const $popup = $("#" + popupId);
    if ($popup.length) {
        $popup.stop(true, true).slideDown();
        return;
    }
    const systemNotificationMaker = new SystemNotificationMaker(notificationInfo);
    systemNotificationMaker.appendToBody();
    $("#" + popupId).stop(true, true).slideDown();
}
function wireNavbarToggle(notificationInfo) {
    $("#systemNotificationToggle").off("click").on("click", () => {
        sessionStorage.setItem("ActiveNotificationClosed", "false");
        displayNotification(notificationInfo);
    });
}
class SystemNotificationMaker {
    constructor(option) {
        this.option = option;
        this.init();
    }
    init() {
        this.eventPopupIds = {
            popupId: `system-notification-popup-container-${this.option.id}`,
            buttonId: `system-notification-button-${this.option.id}`
        };
        this.isNotificationChecked = CookieLibrary.getCookie(this.option.cookieName) != null;
    }
    getHtml() {
        var _a, _b;
        const warnIconEl = kendo.ui.icon({ icon: "warning-triangle" });
        const warnIconHtml = (_b = (_a = warnIconEl[0]) === null || _a === void 0 ? void 0 : _a.outerHTML) !== null && _b !== void 0 ? _b : String(warnIconEl);
        return `<div id="${this.eventPopupIds.popupId}" class="system-notification-popup-container theme-${this.option.themeClass}">
                <div class="system-notification-popup-content">
                    ${warnIconHtml}
                    <p class="system-notification-popup-sub-headline">${this.option.text}</p>
                </div>
                <div>
                    <button id="${this.eventPopupIds.buttonId}" class="k-icon k-i-x" style="background-color:#FFCD00" type="button"></button>
                </div>
            </div>`;
    }
    getBindingConfig() {
        return this.eventPopupIds;
    }
    appendToBody() {
        const htmlContent = this.getHtml();
        if (htmlContent) {
            $(function () {
                $("body").append(htmlContent);
                this.setButtonEvents();
            }.bind(this));
        }
    }
    setButtonEvents() {
        $("#" + this.eventPopupIds.buttonId)
            .off("click")
            .on("click", () => this.buttonClick());
    }
    buttonClick() {
        $("#" + this.eventPopupIds.popupId).stop(true, true).slideUp();
        sessionStorage.setItem("ActiveNotificationClosed", "true");
    }
}
//# sourceMappingURL=SystemNotificationMaker.js.map